import { CodeInputLight } from '@/components/code-input/code-input.light';
import { type TwoFactorCodeProps } from '../-model/props';

export function TwoFactorCodeLight({
  codeValue,
  codeId,
  codeErrors,
  isValidating,
  isSending,
  captchaChallenge,
  onCaptchaChange,
  onCodeChange,
  onResend,
  onSubmit,
}: Readonly<TwoFactorCodeProps>) {
  return (
    <CodeInputLight
      data-tid="otp-two-factor-code"
      codeValue={codeValue}
      codeId={codeId}
      codeErrors={codeErrors}
      isValidating={isValidating}
      isSending={isSending}
      captchaChallenge={captchaChallenge}
      onCaptchaChange={onCaptchaChange}
      onCodeChange={onCodeChange}
      onResend={onResend}
      onSubmit={onSubmit}
    />
  );
}
